import { prefixLanguage } from '@sub/src/utils/urls'
import { BASE_URL } from '@/router/consts'

const p = (postfix: string) => prefixLanguage(`${BASE_URL}${postfix}/`)

export const DISPATCHER_SUM_TABLE = p('dispatcher/table')
